import { FC } from 'react'
import styled from 'styled-components'
import { LayoutHeader } from '@/components/domains/layouts'
import { ListOrders } from '@/components/domains/list'
import { GlobalColorEnum } from '@/constants/global-color.enum'

const PageMyPageCancelReturnExchangeProcessedList: FC = () => {
  return (
    <>
      <LayoutHeader />
      <StyledContainer>
        <ListOrders type="cancel-return-exchange-processed" />
      </StyledContainer>
    </>
  )
}

const StyledContainer = styled.div`
  width: 100%;
  background-color: ${(props) => props.theme.color.gray50};
  min-height: 100vh;
`

export default PageMyPageCancelReturnExchangeProcessedList
